import React from 'react'
import { Typography } from '@material-ui/core'
import Box from 'components/Box'

export default function LegalWrapper(props) {
  const { children } = props
  return (
    <Box maxWidth={800} mx="auto">
      <Typography component="div">{children}</Typography>
    </Box>
  )
}
